import { render, staticRenderFns } from "./popup.vue?vue&type=template&id=2abd6c8a&scoped=true&"
import script from "./popup.vue?vue&type=script&lang=js&"
export * from "./popup.vue?vue&type=script&lang=js&"
import style0 from "./popup.vue?vue&type=style&index=0&id=2abd6c8a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abd6c8a",
  null
  
)

export default component.exports